import React from 'react';
import styled from 'styled-components';
import { TableBody as MuiTableBody, TableRow } from '@material-ui/core';

import { TTableRow } from 'common/types/table';
import { SearchIcon } from 'common/components/icons';

import { Checkbox } from '../Checkbox';

import { TableCell } from './TableCell';

interface IProps {
    className?: string;
    editable?: boolean;
    isRowSelected(rowId: string): boolean;
    tableRows: TTableRow[];
    onRowClick?(rowId: string): void;
    onCheckboxClick?(rowId: string): void;
}

const BaseTableBody = ({
    className,
    editable,
    tableRows,
    isRowSelected,
    onRowClick,
    onCheckboxClick,
}: IProps) => (
    <MuiTableBody className={className} component="div">
        {tableRows.map((row) => {
            const rowIsSelected = isRowSelected(row.id);

            return (
                <TableRow
                    className="tableRow"
                    component="div"
                    key={row.id}
                    selected={rowIsSelected}
                    onClick={() => onRowClick && onRowClick(row.employeeId)}
                >
                    {editable && (
                        <TableCell className="checkboxCell">
                            <Checkbox
                                checked={rowIsSelected}
                                onChange={() =>
                                    onCheckboxClick && onCheckboxClick(row.id)
                                }
                                // Prevent checkbox click from propagating to TableRow click handler
                                onClick={(e) => e.stopPropagation()}
                            />
                        </TableCell>
                    )}

                    {row.cells.map((cell, index) => (
                        <TableCell key={index}>{cell.label}</TableCell>
                    ))}
                </TableRow>
            );
        })}
    </MuiTableBody>
);

export const TableBody = styled(BaseTableBody)`
    ${SearchIcon} {
        opacity: 0;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
    }

    .tableRow {
        position: relative;
        cursor: pointer;

        :hover {
            background-color: ${({ theme }) => theme.palette.primary.light};

            ${SearchIcon} {
                opacity: 1;
            }
        }

        ${TableCell} {
            padding-left: 0;
        }

        &.MuiTableRow-root.Mui-selected,
        &.MuiTableRow-root.Mui-selected:hover {
            background-color: ${({ theme }) => theme.palette.divider};
        }
    }

    .checkboxCell {
        padding-right: 0;
    }

    ${Checkbox} {
        padding-top: 6px;
    }
`;
